
import { Vue, Component, Prop } from 'vue-property-decorator';
import { PackageEnum, PackageItem } from '@/features/shipment/types';
import { getPrice } from '@/features/common/helpers';

@Component
export default class PackageSummary extends Vue {
  @Prop({ required: true }) packages!: Array<PackageItem>;

  @Prop({ default: false }) isQueryStringDebug!: boolean;

  private getDimensions = (item: PackageItem): string => {
    if (item.length && item.width && item.height) {
      return `${item.length} x ${item.width} x ${item.height} ${item.dimUnits}`;
    }
    return '<span class="text-gray">Not Provided</span>';
  };

  private getPrice: (val: number, roundTo: number) => string = getPrice;

  private getWeight = (item: PackageItem): string => `${item.weight.toFixed(1)} ${item.weightUnits}`;

  private getPackageName = (name: string): PackageEnum => PackageEnum[name];

  private deletePackage(idx: number): void {
    this.$emit('delete', idx);
  }

  private getIsAdditionalHandling(item: PackageItem): string {
    return this.$t(`tables.${item.isAdditionalHandling ? 'yes' : 'no'}`) as string;
  }
}
